export default __webpack_public_path__ + "static/media/boiteHero.ef5d4099.jpg";